export const carouselItems = [
  {
    id: 1,
    src: './assets/images/bg.avif',
    title: 'Fashion Frenzy: Unveil the Latest Trends',
  },
  {
    id: 2,
    src: './assets/images/bg-2.jpeg',
    title: 'Elevate Your Wardrobe',
    style: {
      marginLeft: '50rem',
    },
  },
  {
    id: 3,
    src: './assets/images/bg-3.jpeg',
    title: 'Dress to Impress: Own Your Style',
    style: {
      marginLeft: '50rem',
    },
  },
];
